import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';

var _templateObject;
var SideNavLinkContainer = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: ", ";\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n  padding: 0.5rem 0;\n  &:last-child {\n    border-bottom: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.palette.grayLighter);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.palette.grayLighter);
});
var SideNavLinkContainer$1 = withDefaultTheme(SideNavLinkContainer);

export default SideNavLinkContainer$1;
